import { corporationAccount } from "./corporationAccount"
import { ad } from "./ad"
import { swCorporationAccount } from "./swCorporationAccount"

export const general = {
  corporationAccount,
  ad,
  swCorporationAccount,
}
